import styled from '@emotion/styled';

import { useTheme } from '@mui/material';

const Container = styled.div`
  width: ${props => props.$size || "1rem"};
  height: ${props => props.$size || "1rem"};
  border-radius: 50%;
  background-color: ${props => props.$color || "#ccc"};
`

const StatusDot = ({ color, size = ".6rem" }) => {
  const theme = useTheme();

  let themeColor = color ? theme.palette?.[color]?.main : "";
  if (!themeColor && color) {
    themeColor = color
  }

  return (
    <Container $color={themeColor} $size={size} />
  )
}

export default StatusDot;